// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Emq1cbzjU8GZU6iEyLjq{position:absolute;top:24px;left:18px;z-index:var(--zIndex-BASE_1)}`, "",{"version":3,"sources":["webpack://./src/pages/discover/layout/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,QAAA,CACA,SAAA,CACA,4BAAA","sourcesContent":[".collapseButtonContainer {\n  position: absolute;\n  top: 24px;\n  left: 18px;\n  z-index: var(--zIndex-BASE_1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapseButtonContainer": `Emq1cbzjU8GZU6iEyLjq`
};
export default ___CSS_LOADER_EXPORT___;
